<template>
    <div class="project">
        <el-menu theme="dark" :default-active="activeIndex" class="el-menu-demo" mode="horizontal"
                 @select="handleSelect" router>
            <el-menu-item index="/home/performance/performanceLi">绩效管理</el-menu-item>
        </el-menu>
        <router-view></router-view>
    </div>
</template>
<script>

  export default {
    name: 'performanceMenu',
    data() {
      return {
        activeIndex: '/home/performance/performanceLi',
        handleSelect(key, keyPath) {
          console.log(key, keyPath);
        }
      }
    },

  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// performanceMenu.vue?26540262